import { useState } from 'react';
import {
    obtenerUbicacionesPorEmpleado,
    agregarUbicacionAEmpleado,
    actualizarUbicacionEmpleado,
    eliminarUbicacionDeEmpleado
} from '../../../services/empleado/empleadoDetalleService';

const emptyUbicacion = {
    id: null,
    nombre: '',
    descripcion: '',
    esPrincipal: false,
    ubicacionGps: ''
};

export function useUbicaciones({ empleadoId, toast }) {
    const [ubicacionesList, setUbicacionesList] = useState([]);
    const [ubicacionData, setUbicacionData] = useState(emptyUbicacion);
    const [ubicacionDialog, setUbicacionDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [updatingPrincipalId, setUpdatingPrincipalId] = useState(null);

    const recargarUbicaciones = async (id) => {
        if (!id) { setUbicacionesList([]); return; }
        try {
            const data = await obtenerUbicacionesPorEmpleado(id);
            const formateados = data.map(u => ({
                id: u.ubicacionEmpleadoId,
                nombre: u.nombre,
                descripcion: u.descripcion,
                esPrincipal: u.esPrincipal,
                ubicacionGps: u.ubicacionGps
            })).sort((a, b) => a.id - b.id); // ORDENAMIENTO ESTABLE POR ID

            setUbicacionesList(formateados);
        } catch (e) { console.error(e); }
    };

    const openNewUbicacion = () => {
        setUbicacionData(emptyUbicacion);
        setUbicacionDialog(true);
    };

    const openEditUbicacion = (rowData) => {
        setUbicacionData({ ...rowData });
        setUbicacionDialog(true);
    };

    const saveUbicacion = async () => {
        if (!ubicacionData.nombre || !ubicacionData.ubicacionGps) {
            toast.current.show({ severity: 'warn', detail: 'Nombre y Coordenadas son requeridos.' });
            return;
        }

        const payload = {
            empleadoId,
            nombre: ubicacionData.nombre,
            descripcion: ubicacionData.descripcion,
            esPrincipal: ubicacionData.esPrincipal,
            ubicacionGps: ubicacionData.ubicacionGps
        };

        try {
            setLoading(true);
            if (ubicacionData.id) {
                await actualizarUbicacionEmpleado({ ...payload, ubicacionEmpleadoId: ubicacionData.id });
            } else {
                await agregarUbicacionAEmpleado(payload);
            }
            await recargarUbicaciones(empleadoId);
            setUbicacionDialog(false);
            toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Ubicación guardada.' });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error' });
        } finally { setLoading(false); }
    };

    const deleteUbicacion = async (rowData) => {
        if (!window.confirm(`¿Eliminar ubicación ${rowData.nombre}?`)) return;
        try {
            await eliminarUbicacionDeEmpleado(rowData.id);
            await recargarUbicaciones(empleadoId);
            toast.current.show({ severity: 'success', summary: 'Eliminado' });
        } catch (e) { toast.current.show({ severity: 'error', summary: 'Error' }); }
    };

    const handleSetPrincipalUbicacion = async (ubicacion) => {
        if (ubicacion.esPrincipal) return;

        try {
            // 2. ACTIVAR CARGA (General e Individual)
            setLoading(true);
            setUpdatingPrincipalId(ubicacion.id);

            await actualizarUbicacionEmpleado({
                ubicacionEmpleadoId: ubicacion.id,
                empleadoId,
                esPrincipal: true
            });

            await recargarUbicaciones(empleadoId);
            toast.current.show({ severity: 'success', detail: 'Ubicación principal actualizada' });
        } catch (e) {
            toast.current.show({ severity: 'error' });
        } finally {
            // 3. DESACTIVAR CARGA
            setLoading(false);
            setUpdatingPrincipalId(null);
        }
    };

    return {
        ubicacionesList, ubicacionData, setUbicacionData,
        ubicacionDialog, setUbicacionDialog,updatingPrincipalId,
        openNewUbicacion, openEditUbicacion, saveUbicacion, deleteUbicacion,
        handleSetPrincipalUbicacion, recargarUbicaciones, loading, setUbicaciones: setUbicacionesList,
    };
}